import React from "react";

export const TagList = ({ tags = [] }) => {
  if (!tags.length) return null;
  return (
    <section className="mt-12 flex flex-wrap gap-2">
      {tags.map((t) => (
        <span
          key={`tag-${t}`}
          className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#A39E93] border border-[#454038] px-2 py-1"
        >
          #{t}
        </span>
      ))}
    </section>
  );
};

export default TagList;
